import { render, staticRenderFns } from "./EditRevenueOverride.vue?vue&type=template&id=506562a8"
import script from "./EditRevenueOverride.vue?vue&type=script&lang=js"
export * from "./EditRevenueOverride.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports